var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-cart d-flex align-items-center justify-content-center"},[_c('img',{attrs:{"src":require('@/assets/images/ibbil/cart/empty-cart.svg')}})])}
var staticRenderFns = []

export { render, staticRenderFns }